// Use window size hook to determine if we should show the slider or not

// Path: src/hooks/useWindowSize.tsx

import {useCallback, useEffect, useState} from "react";

interface WindowSize {
    width: number | undefined;
    height: number | undefined;
}

const MAX_MOBILE_SCREEN_WIDTH = 853;

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: undefined,
        height: undefined,
    });
    const [isMobile, setIsMobile] = useState(false);

    const handleResize = useCallback(() => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
        setIsMobile(window.innerWidth <= MAX_MOBILE_SCREEN_WIDTH);
    }, []);

    useEffect(() => {


       if(typeof window !== 'undefined') {
            window.addEventListener("resize", handleResize);
            handleResize();

            return () => window.removeEventListener("resize", handleResize);
        }
    }, [handleResize]);

    return {...windowSize, isMobile};
};

export default useWindowSize;